/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-01 14:57:38
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-12-14 14:53:19
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Components/ClickAndCollectDetail/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import {
  SizeFittingTable,
  Image,
  ModalFooter,
  TextArea,
} from 'src/components/Antd';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { EnumTablePosition } from 'src/types/common/common';
import { get } from 'lodash';
import { EType } from 'src/types/common/order';
//import { isNumber } from 'src/tools/helper';
//import { Icon } from '@/src/tools/icon';
import ModalHoc from 'src/constrains/ModalHOC';
import {
  getParcel,
  clickCollectByCode,
  clickCollectByPIN,
} from 'src/request/order';
import { accMul } from 'src/tools/math';
import CustomizationRow from 'src/pages/Order/Components/ExclusiveCustom';
import { Spin } from 'antd';
//import { msg } from 'src/tools/message';
import { Row } from 'src/components/Layouts';
import { ECollectionType } from 'src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Components/Collection';
import CountWords from '@/src/components/CountWords/CountWords';
import { msg } from 'src/tools/message';
//const Option = OriSelect.Option;
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export const mockData = [];

const ClickAndCollectDetail = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };

  const {
    //modalOp,
    uuid,
    //  isPacking,
    type,
    onCancel,
    pin,
    onUpdate,
    customerPaid,
    recipientPhoneNo,
    pickupPersonName,
    totalPrice,
    buyerName,
    pickupLocation,
    transactionInfo,
  } = props;
  const [loading, setLoading] = React.useState(true);
  const [detail, setDetail] = React.useState(null);
  const [parcelItems, setParcelItems] = React.useState([]);
  const [note, setNote] = React.useState('');

  //console.log('actualUnit', actualUnit);

  const assData = (data) => {
    setDetail(data);
    const parcelItems = get(data, 'parcelItems', []);
    setParcelItems(parcelItems);
  };

  React.useEffect(() => {
    getParcel(uuid).then((res) => {
      setLoading(false);
      assData(res);
    });
  }, []);
  //const {}=props

  //   const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
  //     modalOp;
  const tableName = 'OrderDetailPackageDetailTable';
  const data = parcelItems;
  const expandedRows = (data || []).map((i) => i.uuid);

  const handleOnConfirm = () => {
    msg.loading({
      content: getI18n(
        'allOrders.orderDetail.components_ClickAndCollectDetail_handleOnConfirm',
      ),
    });
    if (onUpdate) {
      if (type == ECollectionType.QR) {
        clickCollectByCode({ parcelUuid: uuid, value: pin, notes: note }).then(
          (data) => {
            onCancel();
            onUpdate(data);
          },
        );
      }
      if (type == ECollectionType.Pin) {
        clickCollectByPIN({ parcelUuid: uuid, value: pin, notes: note }).then(
          (data) => {
            onCancel();
            onUpdate(data);
          },
        );
      }
    }
  };

  return (
    <React.Fragment>
      <Spin spinning={loading}>
        <div className={css.container}>
          <div className={css.tableContainer}>
            <SizeFittingTable
              rowKey='uuid'
              scroll={{ y: 430 }}
              pagination={false}
              dataSource={data || []}
              className={css.detailTable}
              id={tableName}
              columns={col({ getI18n })}
              expandable={{
                expandedRowClassName: () => css.expandedRow,
                expandedRowKeys: expandedRows,
                expandIconColumnIndex: -1,
                indentSize: 0,
                expandedRowRender: (record, index) => {
                  //const { customisation } = record;
                  const customisationItem =
                    get(record, 'customisation.items') || [];
                  //const uuid = get(record, 'uuid');
                  const productSetSku = get(record, 'productSetSku');
                  const productSetName = get(record, 'productSetName');
                  const customisation = get(record, 'customisation');

                  const isFromSet = !!productSetSku;

                  return (
                    <React.Fragment>
                      {customisation && (
                        <React.Fragment>
                          <div className={css.customizationLine}>
                            {customisationItem.map((i, index) => {
                              const { title, values } = i;
                              const content = (values || []).join(',');
                              return (
                                <CustomizationRow
                                  key={index}
                                  title={`${title}: ${content}`}
                                  //price={'100'}
                                />
                              );
                            })}{' '}
                          </div>
                        </React.Fragment>
                      )}
                      {isFromSet && (
                        <div className={css.customizationConfirmLineSet}>
                          {getI18n(
                            `allOrders.orderDetail.components_ClickAndCollectDetail_return_tableContainer_productset`,
                          )}{' '}
                          {`${productSetName}(${productSetSku})`}
                        </div>
                      )}
                    </React.Fragment>
                  );
                },
              }}
            />
          </div>
          <div className={css.detailContainer}>
            <div className={css.buyerInfo}>
              <Row
                elements={[
                  {
                    child: (
                      <ItemWrapper
                        title={getI18n(
                          `allOrders.orderDetail.components_ClickAndCollectDetail_return_detailContainer_buyerinfo_buyerchild`,
                        )}>
                        <NoWrapContainer>{buyerName}</NoWrapContainer>
                      </ItemWrapper>
                    ),
                  },
                  {
                    child: (
                      <ItemWrapper
                        title={getI18n(
                          `allOrders.orderDetail.components_ClickAndCollectDetail_return_detailContainer_buyerinfo_Personchild`,
                        )}>
                        <NoWrapContainer>{pickupPersonName}</NoWrapContainer>
                      </ItemWrapper>
                    ),
                  },
                ]}
              />
              <Row
                elements={[
                  {
                    child: (
                      <ItemWrapper
                        title={getI18n(
                          `allOrders.orderDetail.components_ClickAndCollectDetail_return_detailContainer_buyerinfo_storechild`,
                        )}>
                        <NoWrapContainer>
                          <div>{get(pickupLocation, 'locationName', '')}</div>
                          <div>{get(pickupLocation, 'addressLine', '')}</div>
                        </NoWrapContainer>
                      </ItemWrapper>
                    ),
                  },
                  {
                    child: (
                      <ItemWrapper
                        title={getI18n(
                          `allOrders.orderDetail.components_ClickAndCollectDetail_return_detailContainer_buyerinfo_concatchild`,
                        )}>
                        <NoWrapContainer>{recipientPhoneNo}</NoWrapContainer>
                      </ItemWrapper>
                    ),
                  },
                ]}
              />
              <Row
                elements={[
                  {
                    child: (
                      <ItemWrapper
                        title={getI18n(
                          `allOrders.orderDetail.components_ClickAndCollectDetail_return_detailContainer_buyerinfo_datechild`,
                        )}>
                        <NoWrapContainer>
                          {(detail || {}).pickedDate || ''}
                        </NoWrapContainer>
                      </ItemWrapper>
                    ),
                  },
                  {
                    child: <React.Fragment />,
                  },
                ]}
              />
            </div>
            <div className={css.payeeInfo}>
              <Row
                elements={[
                  {
                    child: (
                      <ItemWrapper
                        title={getI18n(
                          `allOrders.orderDetail.components_ClickAndCollectDetail_return_detailContainer_payeeInfo_pricechild`,
                        )}>
                        <NoWrapContainer>{totalPrice}</NoWrapContainer>
                      </ItemWrapper>
                    ),
                  },
                  {
                    child: (
                      <ItemWrapper
                        title={getI18n(
                          `allOrders.orderDetail.components_ClickAndCollectDetail_return_detailContainer_payeeInfo_paymentchild`,
                        )}>
                        <NoWrapContainer>
                          <div>
                            {get(transactionInfo, 'provider')}(
                            {get(transactionInfo, 'paymentMethodName')})
                          </div>
                          <div>
                            {getI18n(
                              `allOrders.orderDetail.components_ClickAndCollectDetail_return_detailContainer_payeeInfo_paymentchild_visa`,
                            )}
                            {customerPaid}
                          </div>
                        </NoWrapContainer>
                      </ItemWrapper>
                    ),
                  },
                ]}
              />
            </div>
          </div>
        </div>
        <div className={css.noteContainer}>
          {' '}
          <ItemWrapper
            title={getI18n(
              `allOrders.orderDetail.components_ClickAndCollectDetail_return_note_title`,
            )}
            rightPart={
              <CountWords count={(note || '').length} allCount={500} />
            }>
            <TextArea value={note} onChange={setNote} maxLength={500} />
          </ItemWrapper>
        </div>

        <ModalFooter
          onOk={handleOnConfirm}
          onCancel={onCancel}
          // hideOkButton={disableOk}
        />
      </Spin>
    </React.Fragment>
  );
};
export default ModalHoc(ClickAndCollectDetail, { width: 980 });
const widthDict = {
  item: { minWidth: 180 },
  sku: { width: 140 },
  qty: {
    width: 60,
  },
  paid: { width: 90 },
};
const col = ({ getI18n }) => {
  return [
    {
      title: getI18n(
        'allOrders.orderDetail.components_packagedetail_colreturn_item_title',
      ),
      key: 'Items (Store)',
      default: true,
      //optional: false,
      //className: css.tableCol,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { productName } = record;
        const thumbnailUrl = get(record, 'image.url');
        //console.log('thumbnailUrl', thumbnailUrl);
        return (
          <div className={css.productNameContainer}>
            <Image
              style={{
                marginRight: 12,
                minWidth: 40,
              }}
              width={40}
              height={40}
              key={thumbnailUrl}
              src={thumbnailUrl}
              alt={thumbnailUrl}
            />

            <NoWrapContainer>
              <GlobalTooltip title={productName || '-'}>
                <div className={css.text}>{productName || '-'}</div>
              </GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },
      ...widthDict['item'],
    },
    {
      title: getI18n('general.sKU'),
      key: 'SKU',
      default: true,
      //optional: false,
      //className: css.tableCol,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { sku } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={sku || '-'}>{sku}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['sku'],
    },
    {
      titleGenerate: () => <span>{getI18n('general.qTY')}</span>,
      key: 'QTY',
      default: true,
      //optional: false,
      //  className: css.tableCol,
      position: EnumTablePosition.right,
      childGenerate: (text, record, index) => {
        // console.log('record', record);
        const { amount } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={amount || '-'}>{amount}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['qty'],
    },
    {
      titleGenerate: () => (
        <div>
          <div>
            {getI18n(
              'allOrders.orderDetail.components_ClickAndCollectDetail_return_detailContainer_payeeInfo_pricechild',
            )}
            .
          </div>
          <div>
            ({getI18n('general.excl')}. {getI18n('general.tax')})
          </div>
        </div>
      ),
      key: 'Paid',
      default: true,
      //optional: false,
      //  className: css.tableCol,
      position: EnumTablePosition.right,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { paidPrice, type, amount } = record;
        if (type === EType.Gift) {
          return <span>Gift</span>;
        }
        const data = accMul(amount, paidPrice).toFixed(2);
        return (
          <NoWrapContainer className={css.paidPrice}>
            <GlobalTooltip title={data}>{data || '-'}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['paid'],
    },
  ];
};
const ItemWrapper = (props) => {
  const { title, children, titlePadding16 } = props;
  return (
    <div className={css.itemWrapperContainer}>
      <div
        className={css.itemWrapperTitle}
        style={titlePadding16 ? { marginBottom: 16 } : {}}>
        {title}
      </div>
      {children}
    </div>
  );
};
